import types from './Types/index';
import dynamic from './Dynamic/index';

const responses = types.all.concat(dynamic);

export default responses;
